import { observer } from 'mobx-react-lite'
import { FieldDropdown } from 'shared/ui'
import { makeTextFieldIcon } from 'shared/ui/TextField'
import { TagsDropdownContext } from 'widgets/TagsDropdown/context/TagsDropdownContext'
import { type TagsDropdownControlStore } from 'widgets/TagsDropdown/store/tagsDropdownControlStore'
import type {
  ITagAction,
  ITagErrorProps,
  TagsDropdownVariant,
  IDropdownAction,
} from 'widgets/TagsDropdown/store/types'
import { TagsDropdownStore } from 'widgets/TagsDropdown/store/tagsDropdownStore'
import { TagsDropdownContent } from 'widgets/TagsDropdown/ui/TagsDropdownContent'
import { TagsDropdownTrigger } from 'widgets/TagsDropdown/ui/TagsDropdownTrigger'
import styles from 'widgets/TagsDropdown/ui/styles.module.scss'

type TagsDropdownProps = {
  controlStore: TagsDropdownControlStore
  labelText?: string
  variant?: TagsDropdownVariant
  limit?: number
  placeholder?: string
  searchPlaceholder?: string
  canCreate?: boolean
  error?: ITagErrorProps | null
  onChange?: (action: ITagAction) => void
  onDropdownChange?: (action: IDropdownAction) => void
  triggerStyle?: 'default' | 'textField'
  width?: number
  showContactsCount?: boolean
}

export const TagsDropdown = observer(
  ({
    controlStore,
    width,
    labelText,
    placeholder,
    triggerStyle = 'default',
    onDropdownChange,
    showContactsCount = true,
  }: TagsDropdownProps) => {
    const useTextFieldStyle = triggerStyle === 'textField'
    const tagsDropdownStore = new TagsDropdownStore({
      controlStore,
      variant: 'formField',
      canCreate: true,
      placeholder,
      hideTriggerLeftIcon: useTextFieldStyle,
      showContactsCount,
    })

    return (
      <TagsDropdownContext.Provider value={tagsDropdownStore}>
        <FieldDropdown
          width={width}
          offset={{ x: 0, y: -1 }}
          labelText={labelText}
          placeholderClassName={useTextFieldStyle ? styles.triggerTextField : undefined}
          onToggle={(status) => {
            if (status) tagsDropdownStore.initSearchStore()
            onDropdownChange?.(status ? 'open' : 'close')
          }}
          triggerComponent={<TagsDropdownTrigger />}
          customComponent={() => <TagsDropdownContent />}
          rightActions={
            useTextFieldStyle
              ? [makeTextFieldIcon({ icon: 'chevronDown', fontSize: 18 })]
              : undefined
          }
        />
      </TagsDropdownContext.Provider>
    )
  }
)
